import { GlobalResponseObject } from '@gtpl/shared-models/common-models';


export class CodeListStatusWiseResponseModel extends GlobalResponseObject {
    active?: number;
    inActive?: number;
    total?: number;
}
